import { render } from "./AddToken.vue?vue&type=template&id=6923283f&scoped=true"
import script from "./AddToken.vue?vue&type=script&lang=js"
export * from "./AddToken.vue?vue&type=script&lang=js"

import "./AddToken.vue?vue&type=style&index=0&id=6923283f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6923283f"]])

export default __exports__